(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('SpecimenDialogController', SpecimenDialogController);

    SpecimenDialogController.$inject = ['Specimen', 'entity', '$timeout', '$uibModalInstance', '$scope'];

    function SpecimenDialogController(Specimen, entity, $timeout, $uibModalInstance, $scope) {
        var vm = this;

        vm.specimen = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specimen.id !== null) {
                Specimen.update(vm.specimen, onSaveSuccess, onSaveError);
            } else {
                Specimen.save(vm.specimen, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:specimenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
